import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { MedicalVisit, TimePeriod } from "../types/FormTypes";
import * as Yup from "yup";
import { medicalVisitAtom } from "./AddCertificate";
import { useRef } from "react";
import { useIsAddMoreTrue } from "./AddMore";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  DatePicker,
  ErrorList,
  Button,
  handleSubmitClick,
  Progressbar,
  MultipleFileUploadField,
  FormTextarea,
  Heading,
} from "@ogt/ui";

export default function ByBoth() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(medicalVisitAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const [isAddMoreTrue] = useIsAddMoreTrue();
  const progress = isAddMoreTrue ? 87 : 62;
  return (
    <div>
      <Formik<MedicalVisit>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });
          navigate("../kostnader-for-overnattning");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          travelDescription: Yup.string().required(
            "Vänligen ange var du reste till och från med bil"
          ),
          dateTo: Yup.string()
            .required("Vänligen ange datum")
            .isOccurredDate()
            .isDateNoEarlierThan(1, TimePeriod.Year),
          dateFrom: Yup.string()
            .required("Vänligen ange datum")
            .isOccurredDate()
            .isDateSameOrAfter(
              "dateTo",
              "Datum från kan inte vare tidigare än datum till"
            ),
          receipts: Yup.array().min(
            1,
            "Vänligen bifoga ett intyg innan du går vidare."
          ),
        })}
      >
        {({ errors, touched, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-40 w-full max-w-xs mb-4">
                {isAddMoreTrue ? (
                  <Progressbar percentage={progress} />
                ) : (
                  <Progressbar percentage={progress} />
                )}
              </div>
            </div>
            <Form ref={formRef}>
              <Box>
                <>
                  <Heading progress={progress} headingRef={h2Ref} focusable>
                    Om resan
                  </Heading>

                  <ErrorList errors={errors} />

                  <Heading as="h3">
                    Resa med både privatbil och kollektivtrafik, taxi eller flyg
                  </Heading>
                  <ul className="mb-10">
                    <li>
                      Du behöver inte bifoga något kvitto eller ange sträcka. Vi
                      beräknar längden på resan från den adress som du är
                      folkbokförd på, till adressen för vårdenheten du besökt.
                      Uppgifterna hittar vi eftersom du angett personnummer och
                      från det intyg du bifogat.
                    </li>
                    <li>
                      Du betalar alltid egenavgiften, 120 kronor per enkelresa,
                      oavsett hur du reser. Det är kostnaderna utöver det som du
                      kan få ersättning för.
                    </li>
                    <li>
                      Resa med egen bild ersätts med 2,50 kronor per kilometer.
                    </li>
                  </ul>

                  <div className="mb-6">
                    <div className="mb-4 md:mb-0">
                      <FormTextarea
                        name="travelDescription"
                        fielddescription
                        currentText={values.travelDescription}
                        label={
                          "1. Ange var du reste till och från med bil (Obligatorisk)"
                        }
                      />
                    </div>
                  </div>
                  <Heading as="h3" className="mb-6">
                    2. Ange datum när du reste med bil (Obligatorisk)
                  </Heading>
                  <div className="md:flex mb-10 md:w-11/12">
                    <div className="mb-6 md:mb-0 md:mr-8 md:w-1/2">
                      <DatePicker
                        name="dateTo"
                        label="Till Vårdenhet (Obligatorisk)"
                        value={formData.dateTo}
                        disableFutureDates
                      />
                    </div>
                    <div className="md:w-1/2">
                      <DatePicker
                        name="dateFrom"
                        label="Från Vårdenhet (Obligatorisk)"
                        value={formData.dateTo}
                        disableFutureDates
                      />
                    </div>
                  </div>
                  <div>
                    <MultipleFileUploadField
                      currentFiles={values.receipts}
                      multiple={true}
                      label="3. Bifoga kvitton eller biljetter för din resa med kollektivtrafik, taxi eller flyg  (Obligatorisk)"
                      inputId="receipts"
                      inputName="receipts"
                    />
                  </div>
                </>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn secondary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
